var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#6CDE07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6562 10.7741C12.6562 12.2197 11.4829 13.1794 9.75037 13.3239V14.625H8.5635V13.311C7.39163 13.1789 6.27822 12.7287 5.34375 12.0094L6.21675 10.8135C6.99469 11.4182 7.731 11.8125 8.61806 11.9441V9.36787C6.62625 8.86837 5.69869 8.14556 5.69869 6.66056C5.69869 5.24137 6.858 4.26881 8.5635 4.13719V3.375H9.75037V4.16363C10.678 4.26666 11.5624 4.61111 12.3154 5.16263L11.5509 6.39787C10.9507 5.96419 10.3371 5.688 9.69581 5.55694V8.05387C11.7697 8.55337 12.6562 9.35494 12.6562 10.7741ZM8.6175 7.77769V5.46469C7.75856 5.5305 7.30856 5.99063 7.30856 6.56888C7.30856 7.12013 7.56731 7.47563 8.61806 7.77825L8.6175 7.77769ZM11.0464 10.8658C11.0464 10.2752 10.7595 9.92025 9.69581 9.61762V11.997C10.5553 11.9306 11.0464 11.4969 11.0464 10.8664V10.8658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.7370eca6ff09fb2b2fcbb1ef3e0e9669.svg";
export { ForwardRef as ReactComponent };